import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { notification } from 'antd';
import { fetchUserPortfolioHistory } from "../../../api/portfolioApi";
import SnapshotCollection from './SnapshotCollection';


const Snapshots = () => {
    const portfolioId = useParams()?.portfolioId;
    const dispatch = useDispatch();
    const [historyData, setHistoryData] = useState([]);

    useEffect(() => {
        if (portfolioId) {
            dispatch(fetchUserPortfolioHistory({ portfolioId, limit: -10 }))
                .then((response) => {
                    if (response.payload && response.payload.historyData) {
                        setHistoryData(response.payload.historyData);
                    }
                })
                .catch((error) => {
                    notification.error({
                        message: 'Error Fetching History',
                        description: `There was an error fetching the portfolio history: ${error.toString()}`
                    });
                });
        }
    }, [portfolioId, dispatch]);

    return (
        <div style={{ padding: '20px' }}>
            <h1>Signal History</h1>
            {historyData.length > 0 ? (
                <SnapshotCollection historyData={[...historyData]} />
            ) : (
                <p>No history data available.</p>
            )}
        </div>
    );
};

export default Snapshots;
